<template>
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
            <div class="content">
                <section class="section--sidebar-user">
                    <!-- <section class="section--title-sidebar">
                        <h3 v-html='getTranslations("title_template_question")'></h3>
                    </section> -->
                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data" v-if="isReady"   class="workflow-tabs">
                            <input type="hidden" name="_token" :value="csrf">
                            <input v-if="this.editing" type="hidden" name="_method" value="PUT">
                            
                            <div class="tab-content">
                                
                                <div class="row mb-3">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label v-html='getTranslations("title_survey_question")'></label>
                                            <input type="text" class="form-control rounded" name="questionBase[name]" :value="this.name">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label v-html='getTranslations("description_survery_question")'></label>
                                            <input type="text" class="form-control rounded" name="questionBase[description]" :value="this.description">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label v-html='getTranslations("sorting_survery_question")'></label>
                                            <input type="number" class="form-control rounded" name="questionBase[sorting]" :value="this.sorting">
                                        </div>    
                                    </div>
                                  <div class="col-12 col-md-4">
                                  <div class="custom-control custom-switch">
                                    <input
                                        name="questionSettings[allow_not_evaluable_skill]"
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="questionSettings[allow_not_evaluable_skill]"
                                        value="1"
                                        v-model="allowNotEvaluableSkill"
                                    />
                                    <label
                                        class="custom-control-label"
                                        for="questionSettings[allow_not_evaluable_skill]"
                                    >
                                      Mostra livello "Non Valutabile"
                                    </label>
                                  </div>
                                </div>
                                    
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">                                                                
                                            <label v-html='getTranslations("selectAssignement")'></label>
                                            <select v-model="this.type_assignement" name="questionSettings[type_assignement]" class="form-control rounded" required>
                                                <option v-for="(name, key) in possible_assignement" :value="key" v-bind:key="key" >
                                                    {{ name }}
                                                </option>
                                            </select>
                                        </div>  
                                    </div>
                                </div>
                                <!-- FIRST SLIDE -->
                                <hr class="mt-2 mb-2">
                                <div class="jumbotron">
                                    <h3 class="display-4" v-html='getTranslations("welcome_slide_intro")'></h3>
                                    <p class="lead" v-html='getTranslations("welcome_slide_explanation")'></p>
                                    <hr class="my-4">                                      
                                    <input-text-and-tags
                                    input_name = "questionSettings[start_slide][message]"
                                    v-bind:input_values = start_slide.message
                                    v-bind:input_user_lang = user_lang
                                    v-bind:input_tags = tags
                                    v-bind:input_langs = languages
                                    v-bind:input_translations = translations>
                                </input-text-and-tags>                                
                            </div>
                            
                            <!-- NO CATEGORY SLIDE -->
                            <hr class="mt-2 mb-2">
                            <div class="jumbotron">
                                <h3 class="display-4" v-html='getTranslations("no_category_slide_intro")'></h3>
                                <p class="lead" v-html='getTranslations("no_category_slide_explanation")'></p>
                                <hr class="my-4">                                                                                        
                                <input-text-and-tags
                                input_name = "questionSettings[no_category][message]"
                                v-bind:input_values = no_category.message
                                v-bind:input_user_lang = user_lang
                                v-bind:input_tags = tags
                                v-bind:input_langs = languages
                                v-bind:input_translations = translations>
                            </input-text-and-tags>
                        </div>
                        
                        <!-- CATEGORY SLIDE -->
                        <hr class="mt-2 mb-2">
                        <div class="jumbotron" v-for="(categoryName, categoryId) in this.categories" v-bind:key=categoryId>
                            <h3 class="display-4">{{ categoryName }}</h3>
                            <p class="lead" v-html='getTranslations("set_message_for_category")'></p>
                            <hr class="my-4">                                                                                        
                            <input-text-and-tags
                            v-bind:input_name = getCategoryMessageInputName(categoryId)
                            v-bind:input_values = getCategoryMessage(categoryId)
                            v-bind:input_user_lang = user_lang
                            v-bind:input_tags = tags
                            v-bind:input_langs = languages
                            v-bind:input_translations = translations>
                        </input-text-and-tags>
                    </div> 
                    
                    <!-- PERSONAL SLIDE -->
                    
                    
                    <hr class="mt-2 mb-2">
                    <div class="jumbotron">
                        <h3 class="display-4" v-html='getTranslations("personal_skills_slide_intro")'></h3>
                        <p class="lead" v-html='getTranslations("personal_skills_slide_explanation")'></p>
                        <div class="form-group">
                            <input type="checkbox" id="can_add_personal_skills" name="questionSettings[can_add_personal_skills]" v-model="can_add_personal_skills" :value="1">
                            <label class="form-check-label" v-html='getTranslations("is_possible_insert_personal_skill")' for="can_add_personal_skills"></label>
                        </div>
                        <hr class="my-4">                                      
                        <input-text-and-tags
                        input_name = "questionSettings[personal_skills][message]"
                        v-bind:input_values = personal_skills.message
                        v-bind:input_user_lang = user_lang
                        v-bind:input_tags = tags
                        v-bind:input_langs = languages
                        v-bind:input_translations = translations>
                    </input-text-and-tags>                                
                </div>
                
                
                <!-- END SLIDE -->
                <hr class="mt-2 mb-2">
                <div class="jumbotron">
                    <h3 class="display-4" v-html='getTranslations("end_slide_intro")'></h3>
                    <p class="lead" v-html='getTranslations("end_slide_explanation")'></p>
                    <hr class="my-4">                                      
                    <input-text-and-tags
                    input_name = "questionSettings[end_slide][message]"
                    v-bind:input_values = end_slide.message
                    v-bind:input_user_lang = user_lang
                    v-bind:input_tags = tags
                    v-bind:input_langs = languages
                    v-bind:input_translations = translations>
                </input-text-and-tags>                                
            </div>
            
            
            <div class="row">
                <div class="col-12">
                    <hr>
                </div>
                <div class="col-12 mt-3 text-right" v-if="can_write">
                    <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                </div>
            </div>    
            
        </div>
    </form>
</section>
</section>
</div>
</vs-popup>
</div>
</template>

<script>
export default {
    
    props: {
        can_write:{
            type:Boolean,
            required:true,
        }
    },
    data () {
        return {
            //default
            title: "Survey Monkey - Skills	",
            active : false,
            action : "",
            name:"",               
            description:"",
            sorting:-1,
            editing : true,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            start_slide: {message: {it: null, en:null}},
            end_slide: {message: {it: null, en:null}},
            no_category: {message: {it: null, en:null}},
            question_configuration: null,
            categories: [],
            tags: [],
            user_lang: 'it',
            translations: {},
            isReady: false,
            can_add_personal_skills: false,
            languages: ['it','en','ch','de'],
            allowNotEvaluableSkill : false,
        }
    },
    methods: {
        toggle(action, item_id, editing, attributes) {               
            this.active     = true;
            this.action     = action;
            this.editing    = editing;
            this.lang       = attributes.lang;
            let dataRoute   = decodeURI(attributes.dataRoute);
            if (dataRoute!==undefined) {
                if (dataRoute.indexOf("[id]")>0) {
                    dataRoute = dataRoute.replace("[id]", item_id);
                }
                axios.get(dataRoute)
                .then((response) => {
                    this.name = response.data.base.name;
                    this.description = response.data.base.description;
                    this.sorting = response.data.base.sorting;
                    this.question_configuration = response.data.question_configuration;
                    this.categories = response.data.categories;                                                        
                    this.tags = response.data.question_configuration.settings["tags"];                                                    
                    this.can_add_personal_skills = response.data.question_configuration.settings["can_add_personal_skills"];
                    this.start_slide = response.data.question_configuration.settings["start_slide"];
                    this.no_category = response.data.question_configuration.settings["no_category"];                            
                    this.personal_skills = response.data.question_configuration.settings["personal_skills"];
                    this.end_slide = response.data.question_configuration.settings["end_slide"];
                    this.user_lang = response.data.user_lang;                            
                    this.translations = response.data.translations;
                    this.cateogries_slide = response.data.question_configuration.settings["cateogries_slide"];
                    this.possible_assignement = response.data.possible_assignement;
                    this.type_assignement = response.data.question_configuration.settings["type_assignement"] != null ? response.data.question_configuration.settings["type_assignement"] : Object.keys(this.possible_assignement)[0];
                    this.isReady = true;
                    this.allowNotEvaluableSkill =  response.data.question_configuration.settings["allow_not_evaluable_skill"];
                    this.can_write = app.__vue__.questionPermission(this.can_write,response.data.base.enable);
                });
            }
        },
        getTranslations(index){
            if (this.translations == null){
                this.translations = [];
            }
            if (typeof(this.translations[index]) === 'undefined'){
                this.translations[index] = "";
            }
            return this.translations[index];
        },
        getCategoryMessageInputName(categoryId){                    
            return "questionSettings[cateogries_slide]["+categoryId+"][message]";
        },
        getCategoryMessage(categoryId){                
            if (this.cateogries_slide == null)
            this.cateogries_slide = [];                
            if (typeof(this.cateogries_slide[categoryId]) === 'undefined'){
                this.cateogries_slide[categoryId] = {'message' : { 'it':null, 'en':null }};
            }
            return this.cateogries_slide[categoryId].message;
        }
    }
}
</script>

